"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ShipmentSearchResponse extends common_1.PaginatedResponse {
}
exports.ShipmentSearchResponse = ShipmentSearchResponse;
//# sourceMappingURL=shipment-search.response.js.map